function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useRef, useEffect } from 'react';
import { tokens } from '@domain-group/fe-brary';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MapPin = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-map/static/map-pin_cd2fab69.png";
var GoogleMapReact = _ref => {
  var className = _ref.className,
    center = _ref.center,
    zoom = _ref.zoom,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? [] : _ref$styles,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? {
      pinUrl: MapPin,
      size: {
        width: 25,
        height: 30
      },
      anchor: {
        x: 12.5,
        y: 15
      }
    } : _ref$icon,
    _ref$exactMarker = _ref.exactMarker,
    exactMarker = _ref$exactMarker === void 0 ? true : _ref$exactMarker,
    _ref$circle = _ref.circle,
    circle = _ref$circle === void 0 ? {
      strokeColor: tokens.colors.primary.base.default,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: tokens.colors.primary.base.default,
      fillOpacity: 0.35,
      radius: 500
    } : _ref$circle,
    _ref$overrideOptions = _ref.overrideOptions,
    overrideOptions = _ref$overrideOptions === void 0 ? {} : _ref$overrideOptions,
    eventListeners = _ref.eventListeners;
  var mapRef = useRef();
  var divRef = useRef(null);
  var fullScreen = useRef(false);
  useEffect(() => {
    if (window !== undefined && window.google !== undefined) {
      var mapOptions = _objectSpread({
        center,
        zoom,
        styles,
        gestureHandling: 'cooperative'
      }, overrideOptions);
      if (divRef.current !== null && !mapRef.current) {
        if (divRef.current) {
          mapRef.current = new window.google.maps.Map(divRef.current, mapOptions);
          eventListeners.onMapCreated(mapRef.current);
          var onBoundsChangedHandler = () => {
            if (mapRef.current) {
              eventListeners.onBoundsChanged(mapRef.current.getBounds());
              var mapDiv = mapRef.current.getDiv().firstElementChild;
              if (mapDiv !== null) {
                var clientHeight = mapDiv.clientHeight,
                  clientWidth = mapDiv.clientWidth;
                var _window = window,
                  innerHeight = _window.innerHeight,
                  innerWidth = _window.innerWidth;
                if (!fullScreen.current && clientHeight === innerHeight && clientWidth === innerWidth) {
                  eventListeners.onExpandMapClick();
                  fullScreen.current = true;
                } else if (fullScreen.current && (clientHeight !== innerHeight || clientWidth !== innerWidth)) {
                  fullScreen.current = false;
                }
              }
            }
          };
          mapRef.current.addListener('click', eventListeners.onMapClick);
          mapRef.current.addListener('rightclick', eventListeners.onRightClick);
          mapRef.current.addListener('dragend', eventListeners.onDragEnd);
          mapRef.current.addListener('zoom_changed', eventListeners.onZoomChanged);
          mapRef.current.addListener('maptypeid_changed', eventListeners.onMapTypeIdChanged);
          mapRef.current.addListener('bounds_changed', onBoundsChangedHandler);
          if (exactMarker) {
            var marker = new window.google.maps.Marker({
              map: mapRef.current,
              position: center,
              icon: icon.pinUrl || MapPin
            });
            marker.addListener('click', () => {
              eventListeners.onMarkerClick(marker);
            });
          } else {
            new google.maps.Circle({
              strokeColor: circle.strokeColor,
              strokeOpacity: circle.strokeOpacity,
              strokeWeight: circle.strokeWeight,
              fillColor: circle.fillColor,
              fillOpacity: circle.fillOpacity,
              map: mapRef.current,
              center,
              radius: circle.radius
            });
          }
        }
      }
    }
  }, [center, zoom, styles, overrideOptions, eventListeners, exactMarker, icon.pinUrl, circle.strokeColor, circle.strokeOpacity, circle.strokeWeight, circle.fillColor, circle.fillOpacity, circle.radius]);
  useEffect(() => {
    if (window !== undefined && window.google !== undefined && mapRef.current) {
      var mapOptions = _objectSpread({
        styles,
        gestureHandling: 'cooperative'
      }, overrideOptions);
      mapRef.current.setOptions(mapOptions);
    }
  }, [styles, overrideOptions]);
  return ___EmotionJSX("div", {
    className: className,
    ref: divRef,
    id: "map"
  });
};
export default GoogleMapReact;